import React from "react";
import PlayerStat from "../PlayerStat";
import {WIN_POINTS_COLOR, WIN_POINTS_COLOR_DARK, WIN_POINTS_COLOR_LIGHT} from "../../../styles/constants";

export function WinPointsStat({text, noShrinkOnMobile, className, isLightColor, isDarkColor}) {
  return (
    <PlayerStat
      text={text}
      color={
        isDarkColor ? WIN_POINTS_COLOR_DARK :
          isLightColor ? WIN_POINTS_COLOR_LIGHT : WIN_POINTS_COLOR
      }
      icon={'/img/icons/win points.png'}
      className={`stat-win-points ${noShrinkOnMobile ? 'no-shrink-on-mobile' : ''} ${className || ''}`}
      title={'Очки'}
    />
  );
}